import { DoctorModule } from './doctors/doctor/doctor.module';
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ERoleAdminString } from '../shared/data/role.enum';
import { AdminOliveGuard } from '../shared/guards/admin-olive.guard';
import { OnlyAdminEmpresaGuard } from '../shared/guards/only-admin-empresa.guard';
import { PermissionsGuard } from '../shared/guards/permissions.guard';
import { AgendaModule } from './agenda/agenda.module';
import { AtendentesModule } from './atendentes/atendentes.module';
import { AtestadosModule } from './atestados/atestados.module';
import { AttendanceReportsModule } from './attendance-reports/attendance-reports.module';
import { CollaboratorReportModule } from './collaborator-report/collaborator-report.module';
import { UnavailableRequestsReportsModule } from './unavailable-requests-reports/unavailable-requests-reports.module';
import { CentroCustosModule } from './centro-de-custos/centro-custos/centro-custos.module';
import { EditCentroCustosModule } from './centro-de-custos/edit-centro-custos/edit-centro-custos.module';
import { CompaniesModule } from './companies/company/companies.module';
import { EditCompanyModule } from './companies/edit-company/edit-company.module';
import { AcessoNegadoComponent } from './components/acesso-negado/acesso-negado.component';
import { ConsultasModule } from './consultas/consultas.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { DevicesModule } from './devices/device/devices.module';
import { EditDeviceModule } from './devices/edit-device/edit-device.module';
import { EditDoctorModule } from './doctors/edit-doctor/edit-doctor.module';
import { EditEmployeeModule } from './employee/edit-employee/edit-employee.module';
import { EmployeeModule } from './employee/employee/employee.module';
import { FilasModule } from './filas/filas.module';
import { FiliaisModule } from './filiais/filiais.module';
import { HistoricoConsultasModule } from './historico-consultas/historico-consultas.module';
import { InicioModule } from './inicio/inicio.module';
import { MyDashboardModule } from './meu-dashboard/my-dashboard.module';
import { ModulesModule } from './modules/modules.module';
import { PacientesModule } from './pacientes/pacientes.module';
import { PagesComponent } from './pages.component';
import { EditPartnerModule } from './partners/edit-partner/edit-partner.module';
import { PartnersModule } from './partners/partner/partners.module';
import { ProximasConsultasModule } from './proximas-consultas/proximas-consultas.module';
import { QuestionariosModule } from './questionarios/questionarios.module';
import { ReasonsModule } from './reasons/reasons.module';
import { RoleManagementModule } from './roles/role-management/role-management.module';
import { RolesModule } from './roles/role/role.module';
import { ServiceInformationModule } from './service-Information/service-information.module';
import { ThemeSettingsModule } from './settings-dashboard/theme-settings/theme-settings.module';
import { EditSetupModule } from './setups/edit-setup/edit-setup.module';
import { SetupModule } from './setups/setup/setups.module';
import { UserSupportModule } from './user-support/user-support.module';
import { UsuariosAdminModule } from './usuarios-admin/usuarios-admin.module';
import { CatalogoProdutosModule } from './catalogo-produtos/catalogo-produtos.module';
import { ClassificacaoSkincareModule } from './classificacao-skincare/classificacao-skincare.module';
import { MotorKitsSkincareModule } from './motor-kits-skincare/motor-kits-skincare.module';

export const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    children: [
      { path: 'acesso-negado', title: 'Acesso negado', component: AcessoNegadoComponent },
      {
        path: 'inicio',
        title: 'Início',
        loadChildren: () => InicioModule,
        canActivate: [PermissionsGuard],
        data: [{}]
      },
      {
        path: 'papeis',
        title: 'Perfis de Acesso',
        loadChildren: () => RolesModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'papeis',
              valor: 'role.list'
            }
          }
        ]
      },
      {
        path: 'papeis/gerenciamento',
        title: 'Gerenciar Perfil de Acesso',
        loadChildren: () => RoleManagementModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'papeis',
              valor: 'role.update'
            }
          }
        ]
      },
      {
        path: 'empresas',
        title: 'Empresas',
        loadChildren: () => CompaniesModule,
        canActivate: [AdminOliveGuard],
        data: [
          {
            claim: {
              nome: 'empresas',
              valor: 'company.list'
            }
          }
        ]
      },
      {
        path: 'empresas/editar',
        title: 'Editar Empresa',
        loadChildren: () => EditCompanyModule,
        canActivate: [AdminOliveGuard],
        data: [
          {
            claim: {
              nome: 'empresas',
              valor: 'company.create'
            }
          }
        ]
      },
      {
        path: 'parceiros',
        title: 'Parceiros',
        loadChildren: () => PartnersModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'parceiros',
              valor: 'partner.list'
            }
          }
        ]
      },
      {
        path: 'parceiros/editar',
        title: 'Editar Parceiro',
        loadChildren: () => EditPartnerModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'parceiros',
              valor: 'partner.create'
            }
          }
        ]
      },
      {
        path: 'medicos',
        title: 'Médicos',
        loadChildren: () => DoctorModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'listar-medicos',
              valor: 'doctor.list'
            }
          }
        ]
      },
      {
        path: 'medicos/editar',
        title: 'Editar Médico',
        loadChildren: () => EditDoctorModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'editar-medicos',
              valor: 'doctor.update'
            }
          }
        ]
      },
      {
        path: 'colaboradores',
        title: 'Colaboradores',
        loadChildren: () => EmployeeModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'listar-colaboradores',
              valor: 'employee.list'
            }
          }
        ]
      },
      {
        path: 'colaboradores/editar',
        title: 'Editar Colaborador',
        loadChildren: () => EditEmployeeModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'editar-colaboradores',
              // O company-api valida employee.update; employee.edit fica até confirmar qual existe nos perfis.
              valor: ['employee.update', 'employee.edit']
            }
          }
        ]
      },
      {
        path: 'centro-custos',
        title: 'Centros de Custo',
        loadChildren: () => CentroCustosModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'listar-centroCustos',
              valor: 'costcenter.list'
            }
          }
        ]
      },
      {
        path: 'centro-custos/editar',
        title: 'Editar Centro de Custo',
        loadChildren: () => EditCentroCustosModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'editar-centroCustos',
              valor: 'costcenter.update'
            }
          }
        ]
      },
      {
        path: 'usuarios-admin',
        title: 'Usuários Admin',
        loadChildren: () => UsuariosAdminModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'listar-usuariosAdmin',
              valor: 'adminuser.list'
            }
          }
        ]
      },
      {
        path: 'filiais',
        title: 'Filiais',
        loadChildren: () => FiliaisModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'listar-filiais',
              valor: 'subsidiary.list'
            }
          }
        ]
      },
      {
        path: 'filiais/editar',
        title: 'Editar Filial',
        loadChildren: () => FiliaisModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'editar-filiais',
              valor: 'subsidiary.update'
            }
          }
        ]
      },
      {
        path: 'questionarios',
        title: 'Questionários',
        loadChildren: () => QuestionariosModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin, ERoleAdminString.QuestionnaireAdmin],
            claim: {
              nome: 'questionarios',
              valor: 'questionnaire.list'
            }
          }
        ]
      },
      {
        path: 'atestados',
        title: 'Atestados',
        loadChildren: () => AtestadosModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Doctor],
            claim: {
              nome: 'listar-atestados',
              valor: 'sicknote.list'
            }
          }
        ]
      },
      {
        path: 'atestados/:id',
        title: 'Atestado',
        loadChildren: () => AtestadosModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Doctor],
            claim: {
              nome: 'editar-atestados',
              valor: 'sicknote.update'
            }
          }
        ]
      },
      {
        path: 'agenda',
        title: 'Agenda',
        loadChildren: () => AgendaModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Doctor],
            claim: {
              nome: 'agenda',
              valor: 'appointments.switchdoctor'
            }
          }
        ]
      },
      {
        path: 'consultas',
        title: 'Solicitações de Consultas',
        loadChildren: () => ConsultasModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Doctor],
            claim: {
              nome: 'consultas',
              valor: 'appointments.list'
            }
          }
        ]
      },
      {
        path: 'historico',
        title: 'Histórico de Consultas',
        loadChildren: () => HistoricoConsultasModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Doctor],
            claim: {
              nome: 'historico',
              valor: 'appointments.list'
            }
          }
        ]
      },
      {
        path: 'proximas-consultas',
        title: 'Consultas Agendadas',
        loadChildren: () => ProximasConsultasModule,
        canActivate: [PermissionsGuard, OnlyAdminEmpresaGuard],
        data: [
          {
            role: [ERoleAdminString.Doctor],
            claim: {
              nome: 'proximas-consultas',
              valor: 'appointments.list'
            }
          }
        ]
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        loadChildren: () => DashboardModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'dashboard',
              valor: 'dashboard.view'
            }
          }
        ]
      },
      {
        path: 'my-dashboard',
        title: 'Configurar Meu Dashboard',
        loadChildren: () => MyDashboardModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'dashboard',
              valor: 'dashboard.list'
            }
          }
        ]
      },
      {
        path: 'categoria/editar',
        title: 'Editar Categoria',
        loadChildren: () => QuestionariosModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin, ERoleAdminString.QuestionnaireAdmin],
            claim: {
              nome: 'categoria',
              valor: 'questionnaire.category.manage'
            }
          }
        ]
      },
      {
        path: 'questionarios/editar',
        title: 'Editar Questionário',
        loadChildren: () => QuestionariosModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin, ERoleAdminString.QuestionnaireAdmin],
            claim: {
              nome: 'questionarios',
              valor: 'questionnaire.edit'
            }
          }
        ]
      },
      {
        path: 'user-support',
        title: 'Atendimento',
        loadChildren: () => UserSupportModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Master, ERoleAdminString.Admin, ERoleAdminString.Doctor],
            claim: {
              nome: 'user-support',
              valor: 'user-support.list'
            }
          }
        ]
      },
      {
        path: 'dispositivos',
        title: 'Dispositivos',
        loadChildren: () => DevicesModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Master, ERoleAdminString.Admin],
            claim: {
              nome: 'device',
              valor: 'device.list'
            }
          }
        ]
      },
      {
        path: 'dispositivos/editar',
        title: 'Editar Dispositivo',
        loadChildren: () => EditDeviceModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Master, ERoleAdminString.Admin],
            claim: {
              nome: 'device',
              valor: 'device.edit'
            }
          }
        ]
      },
      {
        path: 'atendentes',
        title: 'Atendentes',
        loadChildren: () => AtendentesModule,
        canActivate: [AdminOliveGuard],
        data: [
          {
            claim: {
              nome: 'listar-atendentes',
              valor: 'attendants.list'
            }
          }
        ]
      },
      {
        path: 'filas',
        title: 'Filas',
        loadChildren: () => FilasModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'listar-filas',
              valor: 'queue.list'
            }
          }
        ]
      },
      {
        path: 'pacientes',
        title: 'Pacientes',
        loadChildren: () => PacientesModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Doctor],
            claim: {
              nome: 'pacientes',
              valor: 'patients.list'
            }
          }
        ]
      },
      {
        path: 'setups',
        title: 'Setups',
        loadChildren: () => SetupModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'setups',
              valor: ['setup.list']
            }
          }
        ]
      },
      {
        path: 'modulos',
        title: 'Módulos',
        loadChildren: () => ModulesModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'modulos',
              valor: 'module.list'
            }
          }
        ]
      },
      {
        path: 'catalogo-produtos',
        title: 'Catálogo de Produtos',
        loadChildren: () => CatalogoProdutosModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'catalogo-produtos',
              valor: 'skincare.list'
            }
          }
        ]
      },
      {
        path: 'motor-kits-skincare',
        title: 'Motor por Kits',
        loadChildren: () => MotorKitsSkincareModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'motor-kits-skincare',
              valor: 'skincare.list'
            }
          }
        ]
      },
      {
        path: 'classificacao-skincare',
        title: 'Classificação dos Resultados',
        loadChildren: () => ClassificacaoSkincareModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'classificacao-skincare',
              valor: 'skincare.list'
            }
          }
        ]
      },
      {
        path: 'setups/editar',
        title: 'Editar Setup',
        loadChildren: () => EditSetupModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin],
            claim: {
              nome: 'setups',
              valor: ['setup.list']
            }
          }
        ]
      },
      {
        path: 'service-information',
        title: 'Informações do Atendimento',
        loadChildren: () => ServiceInformationModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin, ERoleAdminString.Master],
            claim: {}
          }
        ]
      },
      {
        path: 'relatorios',
        title: 'Atendimentos Realizados',
        loadChildren: () => AttendanceReportsModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Master, ERoleAdminString.Admin],
            claim: {
              nome: 'listar-relatorios',
              valor: 'reports.list'
            }
          }
        ]
      },
      {
        path: 'solicitacoes-atendimento',
        title: 'Solicitações de Atendimento',
        loadChildren: () => UnavailableRequestsReportsModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Master, ERoleAdminString.Admin, ERoleAdminString.Manager],
            claim: {
              nome: 'listar-solicitacoes',
              valor: 'request-reports.list'
            }
          }
        ]
      },
      {
        path: 'relatorio-colaboradores',
        title: 'Relatório de Colaboradores',
        loadChildren: () => CollaboratorReportModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Master, ERoleAdminString.Admin],
            claim: {
              nome: 'listar-relatorios',
              valor: 'collaborator-reports.list'
            }
          }
        ]
      },
      {
        path: 'motivos-atendimento',
        title: 'Motivos de Atendimento',
        loadChildren: () => ReasonsModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Master, ERoleAdminString.Admin, ERoleAdminString.Manager],
            claim: {
              nome: 'motivos-atendimento',
              valor: 'reason.list'
            }
          }
        ]
      },
      {
        path: 'temas',
        title: 'Temas',
        loadChildren: () => ThemeSettingsModule,
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Master, ERoleAdminString.Admin],
            claim: {
              nome: 'temas',
              valor: 'settings.view'
            }
          }
        ]
      },
      // rota antiga, mantida só para não quebrar favoritos e links já compartilhados (OE-1620)
      // eslint-disable-next-line no-restricted-syntax
      { path: 'configurações', redirectTo: 'temas' },
      {
        path: 'pesquisa-nps',
        title: 'Pesquisa NPS',
        loadChildren: () => import('./pesquisa-nps/pesquisa-nps.module').then((m) => m.PesquisaNpsModule),
        canActivate: [PermissionsGuard],
        data: [{ role: [ERoleAdminString.Admin] }]
      },
      {
        path: 'questionario-skincare',
        title: 'Questionário SkinCare',
        loadChildren: () =>
          import('./questionario-skincare/questionario-skincare.module').then((m) => m.QuestionarioSkincareModule),
        canActivate: [PermissionsGuard],
        data: [
          {
            role: [ERoleAdminString.Admin, ERoleAdminString.QuestionnaireAdmin],
            claim: {
              nome: 'questionario-skincare',
              valor: 'skincare.list'
            }
          }
        ]
      },
      {
        path: 'perfil',
        title: 'Meu Perfil',
        loadChildren: () => import('./perfil/perfil.module').then((m) => m.PerfilModule)
      }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule {}
